import { McpTokenScope } from 'Apis/library';

export type McpScopeOption = {
    value: McpTokenScope;
    label: string;
    description: string;
};

/**
 * The scopes an MCP access token can carry, in the order they are offered.
 *
 * Shared by the token creation form and the skills catalog so a scope is named
 * the same way in both places — a customer reading "Insights" on a skill needs
 * to find "Insights" on the checkbox, not a second wording of the same grant.
 */
export const SCOPE_OPTIONS: readonly McpScopeOption[] = [
    {
        value: 'amp.analytics.read',
        label: 'Analytics',
        description: 'Run guarded SQL queries against your tenant analytics tables.',
    },
    {
        value: 'amp.insights.read',
        label: 'Insights',
        description: 'Query and aggregate user coverage and Risk Advisor findings.',
    },
    { value: 'amp.findings.read', label: 'Findings', description: "Read a user's findings and the finding catalog." },
    { value: 'amp.directory.read', label: 'Directory', description: 'List departments and engagement channels.' },
];

/** Falls back to the raw scope so an unmapped grant is still legible. */
export const scopeLabel = (scope: McpTokenScope): string =>
    SCOPE_OPTIONS.find((option) => option.value === scope)?.label ?? scope;
